import * as React from 'react';
import { inputFormatters } from '@blend/ui-common';
import { getIdFromName } from 'login-components/Common/Inputs/inputUtils';
import DataInput from '../DataInput';

class SSNInput extends React.Component<InputProps, {}> {
  // @ts-ignore
  private inputProps: DirectInputProps;
  // @ts-ignore
  private contextProps: DataInputContextProps;

  render() {
    const { input, placeholder, meta, label } = this.props;
    this.inputProps = {
      ...input,
      id: getIdFromName(input.name),
      placeholder,
      type: 'text',
    };

    this.contextProps = {
      label: label || /* istanbul ignore next: (UI-5482) */ '',
      normalize: inputFormatters.SSN.normalize,
      format: inputFormatters.SSN.format as any,
      error: meta.touched && /* istanbul ignore next: (UI-5482) */ meta.error,
    };

    return (
      <div className="SSNInput">
        <DataInput inputProps={this.inputProps} contextProps={this.contextProps} />
      </div>
    );
  }
}

export const SSNInputConfig = {
  component: SSNInput,
  requiredLength: 9,
};

export default SSNInput;
